import { render, staticRenderFns } from "./access_data.vue?vue&type=template&id=864080c2"
import script from "./access_data.vue?vue&type=script&lang=js"
export * from "./access_data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports